<template>
  <div>
    <slice />
    <div class="container">
        <div class="title">{{info.title}}</div>
        <div class="descripation">{{info.create_time}}</div>
        <div class="content" v-html="info.content"></div>
    </div>
  </div>
</template>


<script>
import slice from '../../components/slice.vue';
import { NewsContent } from '@/api';
export default {
  name:'news-content',
  components:{
    slice
  },
  data(){
    return {
      info:{}
    }
  },
  mounted(){
    var id = this.$route.query.id;
    this.getNewsContent(id);
  },
  methods:{
    getNewsContent(id){ //获取新闻列表
      var that = this;
      NewsContent({id:id}).then(res=>{
        that.info = res.data;
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    width: 1200px;
    margin: 0 auto;
  }
  .nav{
    margin-top:30px;
    margin-bottom: 30px;
    font-size: 16px;
    font-weight: bold;
  }
  .title{
    text-align: center;
    color: #333;
    font-size: 18px;
    font-weight: bolder;
    margin-top:25px;
    margin-bottom: 10px;
  }
  .descripation{
    width: 100%;
    text-align: center;
  }
  .content{
    margin-bottom: 25px;
  }
</style>